var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import ReactTimeAgo from './ReactTimeAgo'; // Could have been `import { Tooltip } from 'react-responsive-ui'`
// but in that case Webpack bundles the whole `react-responsive-ui` package.

import Tooltip from 'react-responsive-ui/commonjs/Tooltip';
export default function TimeAgo(props) {
  return React.createElement(ReactTimeAgo, _extends({}, props, {
    container: Container,
    tooltip: false
  }));
}

var Container = function Container(_ref) {
  var verboseDate = _ref.verboseDate,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['verboseDate', 'children']);

  return React.createElement(Tooltip, _extends({
    content: verboseDate
  }, rest), children);
};

Container.propTypes = {
  verboseDate: PropTypes.string
};